const state= {
    Items:{
        items:[],
        total:0,
    }
};

const getters = {
    Items : (state) => state.Items,
};


const actions = {
    async getNofications({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/uob/notification`, {params:params})
                .then(response => {
                    commit( 'setItems', response.data.data );
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async getTransaction({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.get(`api/uob/transaction`, {params:params})
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async invokePayment({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/uob/payment`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
    async generateQr({commit}, params){
        return new Promise (( resolve, reject ) => {
            global.axios.post(`api/uob/generate-qr`, params)
                .then(response => {
                    resolve( response.data.data );
                })
                .catch(error => reject( error ));
        });
    },
};

const mutations = {
    setItems (state, data) {
        state.Items = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
